module.exports = __webpack_public_path__ + "img/jkfx.095683df.png";